import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';

import {Constant} from '../../common/constant';

@Injectable()
export class TransactionsService {

    constructor(private http: HttpClient) {
    }

    /**
     * Build the query string for the transactions endpoint.
     * @param {object} params
     * */
    private fnBuildTransactionsUrl(params?: object): string {
        let urlSearchParams = new HttpParams();
        for (const key in params) {
            if (params.hasOwnProperty(key) && params[key]) {
                urlSearchParams = urlSearchParams.append(key, params[key]);
            }
        }
        const qString = urlSearchParams.toString();
        return Constant.API_URL + 'api/transactions' + (qString ? '?' + qString : '');
    }

    /**
     * Get transactions as an Observable.
     *
     * Prefer this over {@link fnGetTransactions} for the list view: because it is an
     * Observable, the caller can use switchMap to cancel an in-flight request when a
     * newer one is issued, which prevents a slow earlier response from overwriting the
     * results of a newer filter.
     * @param {object} params
     * */
    getTransactions$(params?: object): Observable<any> {
        return this.http.get(this.fnBuildTransactionsUrl(params));
    }

    /**
     * Get transactions (Promise). Kept for one-off calls such as the CSV export where
     * request cancellation is not relevant.
     * @param {object} params
     * */
    fnGetTransactions(params?: object) {
        return new Promise((resolve, reject) => {
            this.http
                .get(this.fnBuildTransactionsUrl(params))
                .subscribe((response) => {
                    resolve(response);
                }, (error) => {
                    reject(error.error);
                });
        });
    }

}
